import abap from "refractor/abap";
export default abap;